import { ConfigValues, DiscountType } from '../types';

// Define a mapping from the interface keys to common names
const configKeyMappings: Record<
  keyof ConfigValues,
  (values: Partial<ConfigValues>) => string | null
> = {
  discountType: () => 'Offer Type',
  discountCode: (values) => {
    if (values.discountType === DiscountType.SHOPIFY_DISCOUNT_CODE) {
      return 'Offer Code';
    }

    return null;
  },
  discountFondueUrl: (values) => {
    if (values.discountType === DiscountType.FONDUE_CASHBACK_URL) {
      return 'Offer Link';
    }

    return null;
  },
  discountFondueDescription: (values) => {
    if (values.discountType === DiscountType.FONDUE_CASHBACK_URL) {
      return 'Offer Details';
    }

    return null;
  },
  discountDescription: () => 'Offer Details',
  fallbackSMS: () => 'Fallback Message',
  supportEmail: () => 'Support Email',
  supportSMS: () => 'Support Message',
  isLiveMode: () => 'Is Live Mode',
  excludedProductTags: () => 'Product Catalog',
  outreachMessages: () => null,
};

// Function to get a user-friendly name from a key
export const configValuesToCommonName = (
  key: keyof ConfigValues,
  values: Partial<ConfigValues>,
): string | null => {
  return configKeyMappings[key](values) || null; // Fallback to the key itself if not found
};
